const MWarehouseOfficer = [
  {
    title: 'Dashboard',
    is_heading: false,
    is_active: false,
    link: {
      name: 'wo.dashboard'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-objects-column',
    active_icon: 'fad fa-objects-column'
  }
]

const MWOPurchaseOrders = [
  {
    title: 'Purchase Orders',
    is_heading: true,
    is_active: false,
    link: {
      name: 'wo.purchase-orders'
    },
    class_name: 'mt-3 font-weight-bolder'
  },
  {
    title: 'Requests',
    is_heading: false,
    is_active: false,
    link: {
      name: 'wo.purchase-orders.requests'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-cart-circle-plus',
    active_icon: 'fad fa-cart-circle-plus'
  },
  {
    title: 'Approvals',
    is_heading: false,
    is_active: false,
    link: {
      name: 'wo.purchase-orders.approvals'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-cart-circle-check',
    active_icon: 'fad fa-cart-circle-check'
  },
  {
    title: 'Posting',
    is_heading: false,
    is_active: false,
    link: {
      name: 'wo.purchase-orders.posting'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-code-compare',
    active_icon: 'fad fa-code-compare'
  },
  {
    title: 'Receiving',
    is_heading: false,
    is_active: false,
    link: {
      name: 'wo.purchase-orders.receiving'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-cart-circle-arrow-down',
    active_icon: 'fad fa-cart-circle-arrow-down'
  }
]

const MWOAuthorityToWithdraws = [
  {
    title: 'ATWs',
    is_heading: true,
    is_active: false,
    link: {
      name: 'wo.atws'
    },
    class_name: 'mt-3 font-weight-bolder'
  },
  {
    title: 'Receiving',
    is_heading: false,
    is_active: false,
    link: {
      name: 'wo.atws.receiving'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-cart-circle-arrow-down',
    active_icon: 'fad fa-cart-circle-arrow-down'
  }
]

const MWOInterWarehouses = [
  {
    title: 'Inter Warehouses',
    is_heading: true,
    is_active: false,
    link: {
      name: 'wo.inter-warehouses'
    },
    class_name: 'mt-3 font-weight-bolder'
  },
  {
    title: 'Transfers',
    is_heading: false,
    is_active: false,
    link: {
      name: 'wo.inter-warehouses.transfers'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-cart-circle-arrow-up',
    active_icon: 'fad fa-cart-circle-arrow-up'
  },
  {
    title: 'Posting',
    is_heading: false,
    is_active: false,
    link: {
      name: 'wo.inter-warehouses.posting'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-code-compare',
    active_icon: 'fad fa-code-compare'
  },
  {
    title: 'Receiving',
    is_heading: false,
    is_active: false,
    link: {
      name: 'wo.inter-warehouses.receiving'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-cart-circle-arrow-down',
    active_icon: 'fad fa-cart-circle-arrow-down'
  }
]

export default MWarehouseOfficer.concat(
  MWOPurchaseOrders,
  MWOAuthorityToWithdraws,
  MWOInterWarehouses
)
